<template>
  <div>
    <v-card class="ma-5 cyan lighten-4">
      <div class="ma-3">
        <div class="d-flex justify-center">
          <h2 class="mt-3">
            <u> รายงานเก็บขยะ / ใบแจ้งหนี้ </u>
          </h2>
        </div>
        <!-- <div class="d-flex justify-center">
          <h3 class="ma-3">{{ getindex_wasteDocument[0].CUSTOMER_NAME }}</h3>
        </div> -->
        <br />
        <div class="d-flex justify-center">
          <h4 class="ma-3">เดือน</h4>
          <div width="290px" class="mr-5">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label=""
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  class="mt-n2"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" type="month" locale="th" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">
                  ยกเลิก
                </v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(date)">
                  ตกลง
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <v-btn color="success" @click="clickSearch">
            ค้นหา<v-icon dark>mdi-card-search-outline </v-icon>
          </v-btn>
          <v-btn class="mx-5" color="error" @click="clickClear">
            ล้าง<v-icon dark> mdi-monitor-clean </v-icon>
          </v-btn>

          <!-- <v-btn class="mx-5" color="error" @click="testQuery">
            ทดสอบ<v-icon dark> mdi-monitor-clean </v-icon>
          </v-btn> -->
        </div>
        <v-simple-table fixed-header dense >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ลำดับ</th>
                <th class="text-left">วันที่</th>
                <th class="text-left">เลขที่ใบ ตช.</th>

                <th class="text-left">ขยะติดเชื้อ</th>
                <th class="text-left">เข็ม</th>
                <th class="text-left">ชื้นเนื้อ/ผ้าอนามัย</th>
                <th class="text-left">ขยะติดเชื้อ อื่นๆ</th>

                <th class="text-left">เคมี</th>
                <th class="text-left">ไซลีน</th>
                <th class="text-left">แอมป์ยา</th>
                <th class="text-left">เคมี อื่นๆ</th>

                <th class="text-left">อันตราย</th>
                <th class="text-left">อันตราย อื่นๆ</th>
                <th class="text-left">จำนวน/กก.</th>
                <th v-if="CustomerGroup == true" class="text-left">
                  จำนวนเงิน
                </th>
                <th class="text-left"></th>

                <!-- <th class="text-left">รูปลายเซ็น</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in getindex_wasteDocument" :key="item.name">
                <td>{{ item.index }}</td>
                <td>{{ item.WALKOUT_DATE | formatDate }}</td>
                <td>{{ item.TRANSACTION_ID }}</td>

                <td>{{ item.WASTE | delimeter }}</td>
                <td>{{ item.NEEDLE | delimeter }}</td>
                <td>{{ item.CHOP | delimeter }}</td>
                <td>{{ item.WASTE_OTHER | delimeter }}</td>

                <td>{{ item.CHEMI | delimeter }}</td>
                <td>{{ item.XYLENE | delimeter }}</td>
                <td>{{ item.AMPOULE | delimeter }}</td>
                <td>{{ item.CHEMI_OTHER | delimeter }}</td>

                <td>{{ item.DANGER | delimeter }}</td>
                <td>{{ item.DANGER_OTHER | delimeter }}</td>
                <td>{{ item.WALKUOT_WEIGHT | delimeter }}</td>

                <td v-if="CustomerGroup == true">
                  {{ item.ALLPRICE | delimeter }}
                </td>

                <!-- 
                <td></td> -->
                <td>
                  <v-btn small @click="printDoc(item)">
                    <!-- <v-icon>mdi-hand-pointing-right</v-icon> -->
                    ตช.
                  </v-btn>
                </td>
              </tr>
              <tr class="teal accent-2">
                <!-- <td>1</td>
                <td>2</td>
                <td>3</td> -->
                <td colspan="3" class="text-center">จำนวนขยะรวม</td>
                <th class="text-left">{{ totalWASTE | delimeter }}</th>
                <th class="text-left">{{ totalNEEDLE | delimeter }}</th>
                <th class="text-left">{{ totalCHOP | delimeter }}</th>
                <th class="text-left">
                  {{ totalWASTE_OTHER | delimeter }}
                </th>

                <th class="text-left">{{ totalCHEMI | delimeter }}</th>
                <th class="text-left">{{ totalXYLENE | delimeter }}</th>
                <th class="text-left">{{ totalAMPOULE | delimeter }}</th>
                <th class="text-left">{{ totalCHEMI_OTHER | delimeter }}</th>

                <th class="text-left">{{ totalDANGER | delimeter }}</th>
                <th class="text-left">
                  {{ totalDANGER_OTHER }}
                </th>

                <th class="text-left">{{ totalWALKUOT_WEIGHT | delimeter }}</th>
                <td></td>
                <!-- <td class="">{{ sumWeight | formatWeight }}</td>
               
                <td colspan="2" class="text-center"></td>
             -->
              </tr>
              <!-- คิดตามกิโล ราคาต่อหน่วย-->
              <tr v-if="CustomerGroup == true">
                <td colspan="3" class="text-center">ราคาต่อหน่วย</td>

                <th class="text-left">{{ objPrice.WASTE | check_objPrice }}</th>
                <th class="text-left">
                  {{ objPrice.NEEDLE | check_objPrice }}
                </th>
                <th class="text-left">{{ objPrice.CHOP | check_objPrice }}</th>
                <th class="text-left">
                  {{ objPrice.WASTE_OTHER | check_objPrice }}
                </th>

                <th class="text-left">{{ objPrice.CHEMI | check_objPrice }}</th>
                <th class="text-left">
                  {{ objPrice.XYLENE | check_objPrice }}
                </th>
                <th class="text-left">
                  {{ objPrice.AMPOULE | check_objPrice }}
                </th>
                <th class="text-left">
                  {{ objPrice.CHEMI_OTHER | check_objPrice }}
                </th>

                <th class="text-left">
                  {{ objPrice.DANGER | check_objPrice }}
                </th>
                <th class="text-left">
                  {{ objPrice.DANGER_OTHER | check_objPrice }}
                </th>
                <th class="text-left"></th>
                <td></td>
              </tr>
              <!-- คิดตามกิโล คำนวนเงินรวม-->
              <tr v-if="CustomerGroup == true">
                <!-- <td>1</td>
                <td>2</td>
                <td>3</td> -->
                <td colspan="3" class="text-center">คำนวนเงินรวม</td>
                <th class="text-left">{{ calulatePriceWASTE | delimeter }}</th>
                <th class="text-left">{{ calulatePriceNEEDLE | delimeter }}</th>
                <th class="text-left">{{ calulatePriceCHOP | delimeter }}</th>
                <th class="text-left">
                  {{ calulatePriceWASTE_OTHER | delimeter }}
                </th>

                <th class="text-left">{{ calulatePriceCHEMI | delimeter }}</th>
                <th class="text-left">{{ calulatePriceXYLENE | delimeter }}</th>
                <th class="text-left">
                  {{ calulatePriceAMPOULE | delimeter }}
                </th>
                <th class="text-left">
                  {{ calulatePriceCHEMI_OTHER | delimeter }}
                </th>

                <th class="text-left">{{ calulateDANGER | delimeter }}</th>
                <th class="text-left">
                  {{ calulatePriceDANGER_OTHER | delimeter }}
                </th>
                <td></td>
                <th colspan="2" class="text-left">
                  {{ calulateAllPrice | delimeter }}
                </th>

                <!-- <td class="">{{ sumWeight | formatWeight }}</td>
               
                <td colspan="2" class="text-center"></td>
             -->
              </tr>
              <!-- รายเดือน รายปี คิดเงินส่วนเกินที่กำหนด-->
              <tr v-if="CustomerGroup == false">
                <!-- <td>1</td>
                
                <td>3</td> -->
                <td colspan="8"></td>
                <td colspan="3" class="text-center">คิดเงินส่วนเกินที่กำหนด</td>
                <td colspan="" class="">{{ Overweight | delimeter }}</td>
                <td colspan="" class="">{{ dataOverweight.price }}</td>
                <td class="text-center">
                  {{ calulatePrice | delimeter }}
                </td>
                <!-- <td>8</td> -->
              </tr>
              <!--รวมจำนวนเงิน-->
              <tr>
                <!-- <td>1</td>
                <td>2</td>
                <td>3</td> -->
                <td colspan="6"></td>
                <td colspan="4" class="text-center"></td>
                <td colspan="2" class="text-center">รวมจำนวนเงิน</td>
                <td colspan="2" class="text-center">
                  {{ allM | delimeter }}
                </td>
                <td></td>
                <!-- <td>7</td>
                <td>8</td> -->
              </tr>
              <!--ภาษีมูลค่าเพิ่ม-->
              <tr>
                <!-- <td>1</td>
                <td>2</td>
                <td>3</td> -->
                <td colspan="6"></td>
                <td colspan="4" class="text-center"></td>
                <td colspan="2" class="text-center">ภาษีมูลค่าเพิ่ม</td>
                <td colspan="2" class="text-center">
                  {{ sumV1s | delimeter }}
                </td>
                <td></td>
                <!-- <td>7</td>
                <td>8</td> -->
              </tr>
              <!--จำนวนรวม-->
              <tr>
                <!-- <td>1</td>
                <td>2</td>
                <td>3</td> -->
                <td colspan="6"></td>
                <td colspan="4" class="text-center"></td>
                <td colspan="2" class="text-center">จำนวนรวม</td>
                <td colspan="2" class="text-center">{{ allL | delimeter }}</td>
                <td></td>
                <!-- <td>7</td>
                <td>8</td> -->
              </tr>
              <!--ภาษีหักณ.ที่จ่าย -->
              <tr>
                <!-- <td>1</td>
                <td>2</td>
                <td>3</td> -->
                <td colspan="6"></td>
                <td colspan="4" class="text-center"></td>
                <td colspan="2" class="text-center">ภาษีหักณ.ที่จ่าย</td>
                <td colspan="2" class="text-center">
                  {{ sumV2s | delimeter }}
                </td>
                <td></td>
                <!-- <td>7</td>
                <td>8</td> -->
              </tr>
              <!--จำนวนรวมทั้งสิ้น -->
              <tr>
                <!-- <td>1</td>
                <td>2</td>
                <td>3</td> -->
                <td colspan="6"></td>
                <td colspan="4" class="text-center"></td>
                <td colspan="2" class="text-center">จำนวนรวมทั้งสิ้น</td>
                <td colspan="2" class="text-center">{{ allL2 | delimeter }}</td>
                <td></td>
                <!-- <td>7</td>
                <td>8</td> -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- <v-simple-table v-else>
          <thead>
            <tr>
              <th class="text-left">สัญญาหมดอายุ</th>
            </tr>

            <tr></tr>
          </thead>
        </v-simple-table> -->
      </div>
    </v-card>
  </div>
</template>
<script>
import moment from "moment";
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import print_document_a5 from "../pdf/printWastDocA5";
export default {
  name: "LinkCusBillReport",
  data() {
    return {
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date
            ? moment(date).add(543, "year").locale("th").format("LL")
            : "";
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
      },
      nowDate: new Date(),
      desserts: [],
      date: new Date().toISOString().substr(0, 7),
      modal: false,
      dataProduct: [],
      r_price: 0,
      sumV1: 0,
      sumV2: 0,
      sumP: 0,
      sumP2: 0,
      objPrice: {},
      CustomerGroup: "",
      dataContract: "",
      dataContractCalculate: {},
      contractP21: "",
      contractP22: "",
      contractP23: "",
      contractP24: "",
      contractP25: "",
      contractP26: "",
      contractP27: "",
    };
  },
  computed: {
    getindex_wasteDocument() {
      return this.desserts.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
    sumWeight() {
      return this.desserts != ""
        ? this.desserts
            .map((item) => item.WALKUOT_WEIGHT)
            .reduce((acc, car) => acc + car)
        : 0;
    },
    dataOverweight() {
      let dc = this.dataContract;
      // console.log("******************************dc");
      // console.log(dc);
      if (
        dc.CUSTOMER_PROVINCE == "เชียงราย" ||
        dc.CUSTOMER_PROVINCE == "ลำปาง"
      ) {
        if (dc.CONTRACT_CATEGORY == "รายเดือน") {
          if (dc.PID == 14 || dc.PID == 16) {
            // console.log("เชียงราย ลำปาง รายเดือน rate 1 w: 75 p: 25");
            let objx = {
              weight: 75,
              price: 25,
            };
            this.dataContractCalculate = objx;
            return objx;
          } else {
            // console.log("เชียงราย ลำปาง รายเดือน rate ! 1 w: 30 p: 25");
            let objx = {
              weight: 30,
              price: 25,
            };
            this.dataContractCalculate = objx;
            return objx;
          }
        } else {
          if (dc.RATE == 1) {
            // console.log("เชียงราย ลำปาง ! รายเดือน rate 1 w: 30 p: 25");
            let objx = {
              weight: 30,
              price: 25,
            };
            this.dataContractCalculate = objx;
            return objx;
          } else {
            // console.log("เชียงราย ลำปาง ! รายเดือน rate ! 1 w: 5 p: 25");
            let objx = {
              weight: 5,
              price: 25,
            };
            this.dataContractCalculate = objx;
            return objx;
          }
        }
      } else {
        if (dc.CONTRACT_CATEGORY == "รายเดือน") {
          console
            .log
            // '-----------------------------if (dc.CONTRACT_CATEGORY == "รายเดือน")'
            ();
          if (dc.RATE == 1) {
            // console.log("! เชียงราย ! ลำปาง รายเดือน rate 1 w: 75 p: 25");
            let objx = {
              weight: 75,
              price: 25,
            };
            this.dataContractCalculate = objx;
            return objx;
          } else {
            // console.log("! เชียงราย ! ลำปาง รายเดือน rate ! 1 w: 30 p: 25");
            let objx = {
              weight: 30,
              price: 25,
            };
            this.dataContractCalculate = objx;
            return objx;
          }
        } else {
          if (dc.RATE == 1) {
            // console.log("! เชียงราย ! ลำปาง ! รายเดือน rate 1 w: 75 p: 25");
            let objx = {
              weight: 75,
              price: 25,
            };
            this.dataContractCalculate = objx;
            return objx;
          } else {
            // console.log("! เชียงราย ! ลำปาง ! รายเดือน rate ! 1 w: 5 p: 25");
            let objx = {
              weight: 5,
              price: 25,
            };
            this.dataContractCalculate = objx;
            return objx;
          }
        }
      }
    },
    Overweight() {
      let dow = this.dataOverweight;
      //console.log('console.log(dow);');
      //console.log(dow);
      //console.log(this.totalWALKUOT_WEIGHT.toFixed(2));
      if (this.totalWALKUOT_WEIGHT.toFixed(2) >= dow.price) {
        let x = this.totalWALKUOT_WEIGHT.toFixed(2) - dow.weight;
        //console.log('x'+x);
        return x;
      } else {
        this.r_price = 0;
        //console.log('return 0');
        return 0;
      }
    },

    calulatePriceCHEMI() {
      return parseFloat(this.totalCHEMI) * parseFloat(this.objPrice.CHEMI);
    },
    calulatePriceXYLENE() {
      return parseFloat(this.totalXYLENE) * parseFloat(this.objPrice.XYLENE);
    },
    calulatePriceAMPOULE() {
      return parseFloat(this.totalAMPOULE) * parseFloat(this.objPrice.AMPOULE);
    },
    calulatePriceCHEMI_OTHER() {
      return (
        parseFloat(this.totalCHEMI_OTHER) *
        parseFloat(this.objPrice.CHEMI_OTHER)
      );
    },
    calulatePriceWASTE() {
      return parseFloat(this.totalWASTE) * parseFloat(this.objPrice.WASTE);
    },
    calulatePriceNEEDLE() {
      return parseFloat(this.totalNEEDLE) * parseFloat(this.objPrice.NEEDLE);
    },
    calulatePriceCHOP() {
      return parseFloat(this.totalCHOP) * parseFloat(this.objPrice.CHOP);
    },
    calulatePriceWASTE_OTHER() {
      return (
        parseFloat(this.totalWASTE_OTHER) *
        parseFloat(this.objPrice.WASTE_OTHER)
      );
    },
    calulateDANGER() {
      return parseFloat(this.totalDANGER) * parseFloat(this.objPrice.DANGER);
    },
    calulatePriceDANGER_OTHER() {
      return (
        parseFloat(this.totalDANGER_OTHER) *
        parseFloat(this.objPrice.DANGER_OTHER)
      );
    },
    calulateAllPrice() {
      let dataR =
        (isNaN(this.calulatePriceCHEMI) == false
          ? this.calulatePriceCHEMI
          : 0) +
        (isNaN(this.calulatePriceXYLENE) == false
          ? this.calulatePriceXYLENE
          : 0) +
        (isNaN(this.calulatePriceAMPOULE) == false
          ? this.calulatePriceAMPOULE
          : 0) +
        (isNaN(this.calulatePriceCHEMI_OTHER) == false
          ? this.calulatePriceCHEMI_OTHER
          : 0) +
        (isNaN(this.calulatePriceWASTE) == false
          ? this.calulatePriceWASTE
          : 0) +
        (isNaN(this.calulatePriceNEEDLE) == false
          ? this.calulatePriceNEEDLE
          : 0) +
        (isNaN(this.calulatePriceCHOP) == false ? this.calulatePriceCHOP : 0) +
        (isNaN(this.calulatePriceWASTE_OTHER) == false
          ? this.calulatePriceWASTE_OTHER
          : 0) +
        (isNaN(this.calulateDANGER) == false ? this.calulateDANGER : 0) +
        (isNaN(this.calulatePriceDANGER_OTHER) == false
          ? this.calulatePriceDANGER_OTHER
          : 0);

      return dataR;
    },
    allM() {
      // console.log("----------------------------- allM()-");
      //console.log(this.dataContract);
      if (this.dataContract.CONTRACT_CATEGORY !== "คิดตามกิโลกรัม") {
        // console.log(
        //   '----------this.dataContract.CONTRACT_CATEGORY !== "คิดตามกิโลกรัม"'
        // );
        // console.log(this.dataContract);
        // console.log(this.calulatePrice);
        // console.log(this.Overweight);
        // console.log(this.r_price);
        if (this.dataContract.CONTRACT_CATEGORY == "รายปี") {
          // console.log("*****รายปี***");
          // console.log(this.contractP26);
          // console.log(this.contractP27);
          let x = parseFloat(this.r_price) + this.dataContract.PRICE;
          this.sumP = x;
          //console.log(x);
          return x;
        } else {
          if (this.dataContract.PID == 14) {
            // console.log("---รายเดือน--30-4-");
            // console.log(this.contractP21);
            // console.log(this.contractP22);
            // console.log(this.contractP23);
            // console.log(this.contractP24);

            if (this.Overweight >= 0 && this.Overweight <= 30) {
              let x = parseFloat(this.contractP21.PRICE);
              this.sumP = x;
              //console.log(x);
              return x;
            } else if (this.Overweight >= 31 && this.Overweight <= 50) {
              let x = parseFloat(this.contractP22.PRICE);
              this.sumP = x;
              //console.log(x);
              return x;
            } else if (this.Overweight >= 51 && this.Overweight <= 75) {
              let x = parseFloat(this.contractP23.PRICE);
              this.sumP = x;
              //console.log(x);
              return x;
            } else if (this.Overweight >= 76) {
              let x =
                parseFloat(this.contractP23.PRICE) +
                parseFloat(this.contractP24.PRICE) * this.calulatePrice;
              this.sumP = x;
              //console.log(x);
              return x;
            }
          } else if (this.dataContract.PID == 16) {
            // console.log("---รายเดือน--30-2-");
            // console.log(this.contractP25);
            if (this.Overweight >= 0 && this.Overweight <= 30) {
              let x = parseFloat(this.contractP21.PRICE);
              this.sumP = x;
              //console.log(x);
              return x;
            } else if (this.Overweight >= 31 && this.Overweight <= 50) {
              let x = parseFloat(this.contractP22.PRICE);
              this.sumP = x;
              //console.log(x);
              return x;
            } else if (this.Overweight >= 51 && this.Overweight <= 75) {
              let x = parseFloat(this.contractP23.PRICE);
              this.sumP = x;
              //console.log(x);
              return x;
            } else if (this.Overweight >= 76) {
              let x =
                parseFloat(this.contractP23.PRICE) +
                parseFloat(this.contractP24.PRICE) * this.calulatePrice;
              this.sumP = x;
              //console.log(x);
              return x;
            }
          } else if (this.dataContract.PID == 15) {
            // console.log("---รายเดือน--20-4-");
            // console.log(this.contractP25);
            if (this.Overweight >= 0 && this.Overweight <= 20) {
              let x = parseFloat(this.contractP25.PRICE);
              this.sumP = x;
              //console.log(x);
              return x;
            } else if (this.Overweight >= 21) {
              let x =
                parseFloat(this.contractP25.PRICE) +
                this.Overweight * this.calulatePrice;
              this.sumP = x;
              //console.log(x);
              return x;
            }
          } else if (this.dataContract.PID == 17) {
            // console.log("---รายเดือน--20-2-");
            // console.log(this.contractP25);
            if (this.Overweight >= 0 && this.Overweight <= 20) {
              let x = parseFloat(this.contractP25.PRICE);
              this.sumP = x;
              //console.log(x);
              return x;
            } else if (this.Overweight >= 21) {
              let x =
                parseFloat(this.contractP25.PRICE) +
                this.Overweight * this.calulatePrice;
              this.sumP = x;
              //console.log(x);
              return x;
            }
          }

          let x = parseFloat(this.r_price) + this.dataContract.PRICE;
          this.sumP = x;
          //console.log(x);
          return x;
        }
      } else {
        let x = this.calulateAllPrice;
        // console.log(x + "this.calulateAllPrice");
        this.sumP = x;
        return x;
      }
    },
    sumV1s() { 
      if (this.dataContract.VAT_VALUE) {
        this.sumP2 = this.sumP * (parseFloat(this.dataContract.VAT_VALUE) / 100);
        return this.sumP * (parseFloat(this.dataContract.VAT_VALUE) / 100);
      } else {
        this.sumP2 = 0;
        return 0;
      }
    },
    sumV2s() { 
      return (
        parseFloat(this.sumP) *
        (parseFloat(this.dataContract.VAT_VALUE2) / 100)
      );
    },
    allL() {
      return this.sumP + this.sumP2;
    },
    allL2() {
      if (
        parseFloat(this.sumP) *
        (parseFloat(this.dataContract.VAT_VALUE2) / 100)
      ) {
        return (
          parseFloat(this.sumP + this.sumP2) -
          parseFloat(this.sumP) *
            (parseFloat(this.dataContract.VAT_VALUE2) / 100)
        );
      } else {
        return parseFloat(this.sumP + this.sumP2);
      }
    },
    totalCHEMI() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) => (item.CHEMI != "-" ? parseFloat(item.CHEMI) : 0))
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalXYLENE() {
      // console.log(this.desserts.length);
      return this.desserts.length > 0
        ? this.desserts
            .map((item) => (item.XYLENE != "-" ? parseFloat(item.XYLENE) : 0))
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalAMPOULE() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) => (item.AMPOULE != "-" ? parseFloat(item.AMPOULE) : 0))
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalCHEMI_OTHER() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) =>
              item.CHEMI_OTHER != "-" ? parseFloat(item.CHEMI_OTHER) : 0
            )
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalWASTE() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) => (item.WASTE != "-" ? parseFloat(item.WASTE) : 0))
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalNEEDLE() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) => (item.NEEDLE != "-" ? parseFloat(item.NEEDLE) : 0))
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalCHOP() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) => (item.CHOP != "-" ? parseFloat(item.CHOP) : 0))
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalWASTE_OTHER() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) =>
              item.WASTE_OTHER != "-" ? parseFloat(item.WASTE_OTHER) : 0
            )
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalDANGER() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) => (item.DANGER != "-" ? parseFloat(item.DANGER) : 0))
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalDANGER_OTHER() {
      return this.desserts.length > 0
        ? this.desserts
            .map((item) =>
              item.DANGER_OTHER != "-" ? parseFloat(item.DANGER_OTHER) : 0
            )
            .reduce((acc, car) => acc + car)
        : 0;
    },
    totalWALKUOT_WEIGHT() {
      // console.log(this.desserts.WALKUOT_WEIGHT);
      return (
        this.totalCHEMI +
        this.totalXYLENE +
        this.totalCHEMI_OTHER +
        this.totalWASTE +
        this.totalNEEDLE +
        this.totalCHOP +
        this.totalWASTE_OTHER +
        this.totalDANGER +
        this.totalDANGER_OTHER
      );
    },
    calulatePrice() {
      // console.log("++++++++++++++++++++++++++calulatePrice()");
      // console.log(this.Overweight);
      // console.log(this.dataContractCalculate.weight);

      let data = this.Overweight - this.dataContractCalculate.weight;
      // console.log(data);
      if (data >= this.dataContractCalculate.weight) {
        let y = parseFloat(data * this.dataContractCalculate.price).toFixed(2);
        this.r_price = y;
        // console.log(this.r_price);
        return y;
      } else {
        console.log(" return 0");
        return 0;
      }
    },
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);

      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      //console.log(typeof x);
      if (x != "NaN") {
        return x;
      } else {
        return 0;
      }
    },
    formatDate(data) {
      return moment(data).add(543, "year").format("DD-MM-YYYY");
    },
    formatWeight(data) {
      return data.toFixed(2);
    },

    sumV1(data) {
      data * parseFloat(this.dataContract[0].VAT_VALUE / 100);
      return;
    },
    sumV2(data) {
      return;
    },
    check_objPrice(data) {
      //console.log(data);
      if (data) {
        return data;
      } else {
        return "-";
      }
    },
  },
  methods: {
    clickClear() {},
    clickSearch() {
      //console.log(typeof this.date);
      let splitY = this.date.split("-")[0];
      let splitM = this.date.split("-")[1];
      let sendYM = splitY + "-" + parseInt(splitM);
      this.selectDetailCustomer(this.$route.params.cus_id, sendYM);
    },
    selectDetailCustomer(cus_id, nowY_M) {
      this.$guest_api
        .post("/data-send-customers", { CUS_ID: cus_id, NOW_YM: nowY_M })
        .then((res) => {
          // console.log(
          //   "--------------------DetailCustomer--ตช---------------------"
          // );
          // console.log(res.data.data);
          //set headers
          //set desserts
          if (res.data.data) {
            this.desserts = res.data.data;
          }

          this.selectDetailContract(cus_id, nowY_M);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectDetailContract(cus_id, nowY_M) {
      this.$guest_api
        .post("/get-data-contract", { CUS_ID: cus_id })
        .then((res) => {
          var dataCon = res.data.data;
          // console.log(
          //   "--------------------DetailContract-----------------------"
          // );

          // console.log(dataCon);
          for (let i = 0; i < dataCon.length; i++) {
            if (dataCon[i].CONTRACT_CATEGORY == "รายเดือน") {
              if (
                dataCon[i].PID == "13" ||
                dataCon[i].PID == "14" ||
                dataCon[i].PID == "15" ||
                dataCon[i].PID == "16" ||
                dataCon[i].PID == "17"
              ) {
                this.dataContract = dataCon[i];
                // console.log(
                //   "---------------------------------------------this.dataContract"
                // );
                // console.log(this.dataContract);
              } else if (dataCon[i].PID == "21") {
                this.contractP21 = dataCon[i];
              } else if (dataCon[i].PID == "22") {
                this.contractP22 = dataCon[i];
              } else if (dataCon[i].PID == "23") {
                this.contractP23 = dataCon[i];
              } else if (dataCon[i].PID == "24") {
                this.contractP24 = dataCon[i];
              } else if (dataCon[i].PID == "25") {
                this.contractP25 = dataCon[i];
              }
            } else if (dataCon[i].CONTRACT_CATEGORY == "รายปี") {
              if (dataCon[i].PID == "18" || dataCon[i].PID == "19") {
                this.dataContract = dataCon[i];
              } else if (dataCon[i].PID == "26") {
                this.contractP26 = dataCon[i];
              } else if (dataCon[i].PID == "27") {
                this.contractP27 = dataCon[i];
              }
            } else if (dataCon[i].CONTRACT_CATEGORY == "คิดตามกิโลกรัม") {
              this.dataContract = dataCon[0];
            }
          }
          this.checkCustomerGroup(res.data.data[0]);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectDetailProduct() {
      this.$guest_api
        .get(`/get-data-product/${this.$route.params.cus_id}`)
        .then(async (res) => {
          // console.log(
          //   "--------------------DetailProduct-----------------------"
          // );
          // console.log(res.data.data);
          this.objPrice = res.data.data;
          //   this.setObjPrice(await res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkCustomerGroup(data) {
      if (data.CONTRACT_CATEGORY == "คิดตามกิโลกรัม") {
        this.CustomerGroup = true;
      } else {
        this.CustomerGroup = false;
      }
    },
    setObjPrice(data) {
      for (let index = 0; index < data.length; index++) {
        if (data[index].NAME == "เคมี (คำนวนราคา)") {
          this.objPrice.CHEMI = data[index].PRICE;
        } else if (data[index].NAME == "ไซลีน (คำนวนราคา)") {
          this.objPrice.XYLENE = data[index].PRICE;
        } else if (data[index].NAME == "แอมป์ยา (คำนวนราคา)") {
          this.objPrice.AMPOULE = data[index].PRICE;
        } else if (data[index].NAME == "เคมี อื่นๆ (คำนวนราคา)") {
          this.objPrice.CHEMI_OTHER = data[index].PRICE;
        } else if (data[index].NAME == "ขยะติดเชื้อ (คำนวนราคา)") {
          this.objPrice.WASTE = data[index].PRICE;
        } else if (data[index].NAME == "เข็ม (คำนวนราคา)") {
          this.objPrice.NEEDLE = data[index].PRICE;
        } else if (data[index].NAME == "ชื้นเนื้อ/ผ้าอนามัย (คำนวนราคา)") {
          this.objPrice.CHOP = data[index].PRICE;
        } else if (data[index].NAME == "ขยะติดเชื้อ อื่นๆ (คำนวนราคา)") {
          this.objPrice.WASTE_OTHER = data[index].PRICE;
        } else if (data[index].NAME == "อันตราย (คำนวนราคา)") {
          this.objPrice.DANGER = data[index].PRICE;
        } else if (data[index].NAME == "อันตราย อื่นๆ (คำนวนราคา)") {
          this.objPrice.DANGER_OTHER = data[index].PRICE;
        }
      }
      // console.log(this.objPrice);
    },
    async printDoc(item) {
      console.log("%c Print Doc start  ", "color:green;font-weight:600;");
      // console.log(item);
      let data;
      await this.$guest_api
        .get("/l-Doc/" + item.TRANSACTION_ID)
        .then((response) => {
          if (response.data.data.length > 0) {
            data = response.data.data[1];
          } else {
            data = response.data.data[0];
          }
        })
        .catch((err) => {
          console.log(err);
        });

      let desSigPic;
      // console.log(item.TRANSACTION_ID);
      await this.$guest_api
        .get(`/get-des-des_sig_pic/${item.TRANSACTION_ID}`)
        .then((res) => {
          desSigPic = res.data.data[0].TR_DESTROY_ID;
          // console.log(desSigPic);
        })
        .catch((err) => {
          console.log(e);
        });
      if (desSigPic) {
        // console.log(data);
        this.getUrlOrigin = this.$img_url_O + `/${item.TRANSACTION_ID}.jpg`;
        this.getUrlRemoval = this.$img_url_R + "/" + desSigPic + ".jpg";
      } else {
        this.getUrlOrigin = this.$img_url_O + `/${item.TRANSACTION_ID}.jpg`;
        this.getUrlRemoval = this.$img_url_R + "/" + "0" + ".jpg";
      }
      // console.log(this.getUrlOrigin);
      // console.log(this.getUrlRemoval);
      // console.log(this.$route.fullPath);
      data.urlO = this.getUrlOrigin;
      data.urlR = this.getUrlRemoval;
      data.rootURL = this.$global_link + "/l-Doc/" + item.TRANSACTION_ID;
      console.log(data);
      console.log("%c Print Doc end  ", "color:red;font-weight:600;");
      this.print_documentpdf_a5(data);
    },
    async print_documentpdf_a5(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await print_document_a5(item,this.$AppName)).open();
    },
  },

  created() {
    let nowY_M =
      new Date().getFullYear() + "-" + parseInt(new Date().getMonth());
    this.selectDetailCustomer(this.$route.params.cus_id, nowY_M);
    this.selectDetailContract(this.$route.params.cus_id, nowY_M);
    this.selectDetailProduct();
  },
};
</script>
